import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Sparkles = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="sparkles icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M14.25 4.5C15.5309 10.0151 19.6674 12.7728 24 14.25C19.6674 15.5306 15.5309 19.6671 14.25 24C12.7732 19.6671 8.63658 15.5306 4.5 14.25C8.63658 12.7728 12.7732 10.0151 14.25 4.5ZM5.25 0C5.9397 2.96968 8.16708 4.45461 10.5 5.25C8.16708 5.93953 5.9397 8.16692 5.25 10.5C4.45477 8.16692 2.22739 5.93953 0 5.25C2.22739 4.45461 4.45477 2.96968 5.25 0Z"
    />
  </svg>
)
